import { usePermission } from '~/hooks/usePermission';

import {
  toValidationConnector,
  type ValidationConnectorCode,
} from '../services/enrichment-validation.service';
import type { BatchHeader } from '../types/catalog-operations.types';

/** The batch-header fields validation needs — any screen holding a batch header can pass it. */
export type RunValidationTarget = Pick<
  BatchHeader,
  'pipelineWorkflowId' | 'workflowId' | 'connectorCode' | 'triggerSource' | 'stages'
>;

/** Run root id (`pipelineWorkflowId ?? workflowId`): the summary, revalidate and repair key. */
export function validationRootId(target: RunValidationTarget | null | undefined): string {
  return target?.pipelineWorkflowId ?? target?.workflowId ?? '';
}

/**
 * The connector a batch shows validation for — a Google Merchant or Meta Commerce run whose
 * enrichment completed, for a viewer with `data_quality:read` — or `null` when it shows none.
 */
export function useCanShowRunValidation(
  target: RunValidationTarget | null | undefined,
): ValidationConnectorCode | null {
  const canRead = usePermission('data_quality:read');
  const connector = toValidationConnector(target?.connectorCode);
  const enrichmentComplete =
    target?.stages.some((s) => s.key === 'enriched' && s.state === 'complete') ?? false;
  return canRead && !!validationRootId(target) && enrichmentComplete ? connector : null;
}
